var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isH5)?_c('H5Share'):_c('Share')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }